import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useOrderAddItemsCatalogNavigation } from '../../lib/useOrderAddItemsCatalogNavigation';

export const AddItemsToOrderButton = () => {
    const { t } = useTranslation();
    const navigateToOrderPropertyCatalog = useOrderAddItemsCatalogNavigation();

    return (
        <Button
            style={{ minWidth: '140px' }}
            variant="outlined"
            onClick={() => navigateToOrderPropertyCatalog()}
            startIcon={<Add />}
            data-testid="btn-add-item"
        >
            {t('Add item')}
        </Button>
    );
};
